<template>
  <div class="d-flex flex-wrap">
      <div class="col-md-3">
       <PanelSales :selectedComissao="selectedComissao"></PanelSales>
      </div>
      <div class="col-md-9">
        <b-tabs v-model="tabIndex">
            <b-tab :title="'Detalhes'">
                <template slot="title">
                    <div>
                        <span class="d-md-down-none pl-1 text-third text-tabs">Detalhes</span>
                    </div>
                </template>
                <DetailsForm :selectedComissao="selectedComissao"></DetailsForm>
            </b-tab>
            <b-tab :title="'Valor de Empreeedimento'">
                <template slot="title">
                    <div>
                        <span class="d-md-down-none pl-1 text-third text-tabs">Valor do Empreendimento</span>
                    </div>
                </template>
                <ValueEnterprise :selectedComissao="selectedComissao"></ValueEnterprise>
            </b-tab>
            <b-tab :title="'Comissões'">
                <template slot="title">
                    <div>
                        <span class="d-md-down-none pl-1 text-third text-tabs">Comissões</span>
                    </div>
                </template>
                <CommissionSales :selectedComissao="selectedComissao"></CommissionSales>
            </b-tab>
        </b-tabs>
      </div>
  </div>
</template>

<script>
import DetailsSales from './detailssales'
export default DetailsSales
</script>

<style scoped>

#body-details{
    height: 100%;
    padding-bottom: 5%;
}

.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
    margin-bottom: 15px;
}

.input-details{
    width: 100%;
    height: 35px;
    background-color: #F1F1F1;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
}

.head-container{
    display: flex;
    justify-content: space-between;
}

.aprtamento{
    font-size:20px;
}
.label-details{
    font-size: 15px;
    color: black;
    margin-bottom: 0px;

}
.result-details{
    font-size: 16px;
    font-weight: bold;

}

#details-board{
    height: 100%;
    width: 100%;
    background-color:white;
}

.text-tabs{
    color: #008148;
}
#card-details{
    width: 100%;
    border: 1px solid rgb(202, 202, 202);
    background-color: white;
    border-radius: 5px;
}

#footer-card-details{
    display: flex;
    font-size: 35px;
}

#nameTower{
    color: rgb(90, 90, 90);
    font-size: 30px;
    font-weight: bold;
}

#card-img{
    height: 250px;
}

#info{
    height: 50px;
    width: 100%;
    font-size: 22px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
}
hr{
    width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesinquiry/components/detailssales/detailssales.vue